import React, { Fragment, useCallback, useEffect, useState } from "react";
import Combinations from "./gamePlay/combinations/Combinations";
import Cards from "./gamePlay/cards/Cards";
import Footer from "./footer/Footer";
import useSound from "use-sound";
import { VIDEO_POKER_PROPS } from "./Interface";

export default function VideoPoker({
  stateRound,
  holded,
  setHolded,
  stake,
  handleAbove,
  gameInfo,
  colors,
  sendSocketMessage,
  canGamble,
  handleStake,
  sendSettings,
  audio,
  audioUrls,
  errorMSG,
  handleNotification,
  notification,
  showGamble,
  isLoaded,
}: VIDEO_POKER_PROPS) {
  const [cleared, setCleared] = useState<boolean>(false);
  const [clearAnim, setClearAnim] = useState<boolean>(false);
  const [cardFront, setCardFront] = useState(false);
  const [localSound, setLocalSound] = useState(false);

  useEffect(() => {
    if (isLoaded && audio.sound) {
      setLocalSound(true);
    } else {
      setLocalSound(false);
    }
  }, [audio.sound, isLoaded]);

  const [backgroundSFX, { stop, sound }] = useSound(audioUrls.background, {
    volume: parseFloat(audio && audio.volume),
  });

  useEffect(() => {
    audio && audio.music && errorMSG === false && isLoaded
      ? (() => {
          backgroundSFX();
          sound.loop(true);
        })()
      : stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [audio.music, backgroundSFX, stop, sound, errorMSG, isLoaded]);

  const handleClearAnim = (e: boolean) => {
    setClearAnim(e);
  };

  const handleCardFront = useCallback((e: boolean) => {
    setCardFront(e);
  }, []);

  const [lastCardRotated, setlastCardRotated] = useState(false);

  const handleLastCardRotate = useCallback((e: boolean) => {
    setlastCardRotated(e);
  }, []);

  useEffect(() => {
    switch (stateRound.state) {
      case 2:
      case 3:
      case 5:
      case 7:
        setTimeout(() => {
          setCardFront(true);
        }, 300);
        break;
      default:
        break;
    }
  }, [stateRound.state]);

  return (
    <Fragment>
      <Combinations
        winType={stateRound.wintype}
        audio={audio && audio.volume}
        lastCardRotated={lastCardRotated}
        state={stateRound.state}
        localSound={localSound}
        coefs={gameInfo.game_settings}
      />

      <Cards
        stateRound={stateRound}
        holded={holded}
        setHolded={setHolded}
        audioUrl={audioUrls}
        cleared={cleared}
        clearAnim={clearAnim}
        cardFront={cardFront}
        handleLastCardRotate={handleLastCardRotate}
        lastCardRotated={lastCardRotated}
        isLoaded={isLoaded}
      />
      <Footer
        handleAbove={handleAbove}
        stake={stake}
        gameInfo={gameInfo}
        stateRound={stateRound}
        colors={colors}
        sendSocketMessage={sendSocketMessage}
        holded={holded}
        isLoaded={isLoaded}
        canGamble={canGamble}
        sendSettings={sendSettings}
        audio={audio}
        audioUrl={audioUrls}
        handleNotification={handleNotification}
        handleStake={handleStake}
        notification={notification}
        setCleared={setCleared}
        handleClearAnim={handleClearAnim}
        handleCardFront={handleCardFront}
        lastCardRotated={lastCardRotated}
        handleLastCardRotate={handleLastCardRotate}
        cardFront={cardFront}
        showGamble={showGamble}
      />
    </Fragment>
  );
}
